import { useEffect } from 'react';

const ThemeHandler = () => {
    useEffect(() => {
        // Determine stored or system preference
        const getPreferredTheme = () => {
            const stored = localStorage.getItem('theme');
            if (stored) return stored;
            return window.matchMedia('(prefers-color-scheme: dark)').matches ? 'dark' : 'light';
        };

        // Apply data-bs-theme attribute
        const setTheme = (theme) => {
            if (theme === 'auto') {
                const isDark = window.matchMedia('(prefers-color-scheme: dark)').matches;
                document.documentElement.setAttribute('data-bs-theme', isDark ? 'dark' : 'light');
            } else {
                document.documentElement.setAttribute('data-bs-theme', theme);
            }
        };

        // Highlight active toggle and update icon
        const showActiveTheme = (theme) => {
            const btn = document.querySelector(`[data-bs-theme-value="${theme}"]`);
            if (!btn) return; // guard against missing element

            // activate button
            document.querySelectorAll('[data-bs-theme-value]').forEach((el) => el.classList.remove('active'));
            btn.classList.add('active');

            // update icon (handle Firefox href vs xlink:href)
            const iconUse = document.querySelector('.theme-icon-active use');
            const toggleUse = btn.querySelector('.mode-switch use');
            const newHref = toggleUse?.getAttribute('href') || toggleUse?.getAttribute('xlink:href');
            if (iconUse && newHref) iconUse.setAttribute('href', newHref);
        };

        // Initial setup
        const initial = getPreferredTheme();
        setTheme(initial);
        showActiveTheme(initial);

        // Wire up clicks
        document.querySelectorAll('[data-bs-theme-value]').forEach((toggle) => {
            toggle.addEventListener('click', () => {
                const chosen = toggle.getAttribute('data-bs-theme-value');
                localStorage.setItem('theme', chosen);
                setTheme(chosen);
                showActiveTheme(chosen);
            });
        });
    }, []);

    return null;
};

export default ThemeHandler;